const Config = {
  hideAfter: 3000
};

export default Config;
